import type { InvestmentProgrammeDocumentDetailsRes } from '@dealstack/shared/lib/generated';

export enum PendingDocumentActionType {
	ASSIGN = 'assign',
	UNASSIGN = 'unassign',
	DOCUMENT_REFRESH = 'documentRefresh',
	CLAIM_GENERATION = 'claimGeneration',
}

export type PendingDocumentAction =
	| {
			action: PendingDocumentActionType.ASSIGN | PendingDocumentActionType.UNASSIGN;
			roleId: string;
			userId: string;
			previousSignerFileId?: string | null;
	  }
	| {
			action: PendingDocumentActionType.DOCUMENT_REFRESH;
			previousUpdatedAt: string | null;
	  }
	| {
			action: PendingDocumentActionType.CLAIM_GENERATION;
			signerId: string;
	  };

export type PendingSignerAssignmentAction = Extract<
	PendingDocumentAction,
	{ action: PendingDocumentActionType.ASSIGN | PendingDocumentActionType.UNASSIGN }
>;

export interface UsePendingDocumentActionArgs {
	/** Latest document detail, refreshed by the SSE stream. */
	documentDetails: InvestmentProgrammeDocumentDetailsRes | undefined;
	/** Refetch used by the synchronous electronic assign/unassign short-circuit. */
	refetch: () => void;
}

export interface UsePendingDocumentActionResult {
	/** True while backend work is still expected to land. */
	isActionPending: boolean;
	/** The in-flight assign/unassign, for per-group spinners. Null otherwise. */
	pendingSignerAssignmentAction: PendingSignerAssignmentAction | null;
	/** True when the expected change never arrived within the timeout. */
	isActionTimedOut: boolean;
	beginPendingAction: (action: PendingDocumentAction) => void;
	clearPendingAction: () => void;
}
